/**
 * AssistantHost — monta o painel de sugestões do assistente como overlay global no
 * AppShell. O BALÃO (SmartAssistantNotice) não fica aqui: o legado o cria dentro do
 * #window da captura [application.js:3771], então quem o renderiza é o CapturePage.
 */
import { SuggestionsDialog } from './SuggestionsDialog';

export function AssistantHost(): JSX.Element {
  return <SuggestionsDialog />;
}
